import DealMarker from "app/DealMachineCore/components/PropertyMap/CustomMarker/DealMarker";
import { Wrapper } from "app/NativeComponents/common";
import { getMapOptions } from "app/NativeComponents/components/Map/MapStyles";
import GoogleMapReact from "google-map-react";
import React, { useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";

const MAP_HEIGHT = 200;
export const CompMap = ({ property, comps, selectedComps }) => {
  const dark_mode = useSelector(
    ({ settings }) =>
      settings.dark_mode && settings.dark_mode != "dark_mode_off"
  );
  const colors = useSelector(({ settings }) => settings.colors);
  const { map_type } = useSelector(({ map }) => map);
  const mapRef = useRef(null);
  const wrapperRef = useRef(null);

  const filteredComps = useMemo(
    () =>
      selectedComps.length > 0
        ? comps.filter(c => selectedComps.includes(c.id))
        : comps,
    [JSON.stringify(comps), JSON.stringify(selectedComps)]
  );

  useEffect(() => {
    if (!mapRef.current || !wrapperRef.current) return;
    const points = [
      {
        lat: parseFloat(property.location.latitude),
        lng: parseFloat(property.location.longitude)
      },
      ...filteredComps.map(c => ({
        lat: parseFloat(c.position_latitude),
        lng: parseFloat(c.position_longitude)
      }))
    ];

    if (points.length == 1) {
      mapRef.current.setCenter(
        new window.google.maps.LatLng(points[0].lat, points[0].lng)
      );
      mapRef.current.setZoom(17);
      return;
    }
    const bounds = new window.google.maps.LatLngBounds();
    points.forEach(({ lat, lng }) =>
      bounds.extend(new window.google.maps.LatLng(lat, lng))
    );

    mapRef.current.fitBounds(bounds, 10);
  }, [JSON.stringify(filteredComps), mapRef.current, wrapperRef.current]);

  return (
    <div
      ref={wrapperRef}
      style={{ height: MAP_HEIGHT, width: "100%", background: "lightblue" }}
    >
      <GoogleMapReact
        bootstrapURLKeys={{ key: "AIzaSyBKxAXFBe8TSxxLFX6jDKxZdTu8-rdv_6s" }}
        defaultCenter={{
          lat: parseFloat(property.location.latitude),
          lng: parseFloat(property.location.longitude)
        }}
        options={{
          ...getMapOptions(map_type, dark_mode),
          maxZoom: 20,
          minZoom: null
        }}
        zoom={17}
        onGoogleApiLoaded={({ map }) => {
          mapRef.current = map;
        }}
      >
        <Wrapper
          style={{
            borderRadius: "50%",
            height: 10,
            width: 10
          }}
          lat={parseFloat(property.location.latitude)}
          lng={parseFloat(property.location.longitude)}
        >
          <DealMarker showPropertyMarker={true} is_active_property={true} />
        </Wrapper>
        {comps.map(c => (
          <Wrapper
            key={"" + c.id}
            style={{
              width: 14,
              height: 14,
              borderRadius: 7,
              alignItems: "center",
              justifyContent: "center",
              shadowColor: "#000",
              shadowOpacity: 0.2,
              shadowOffset: { width: 0, height: 2 },
              backgroundColor: colors.card_color,
              zIndex: selectedComps.includes(c.id) ? 6 : 5
            }}
            lat={parseFloat(c.position_latitude)}
            lng={parseFloat(c.position_longitude)}
          >
            <Wrapper
              style={{
                width: 10,
                height: 10,
                borderRadius: 5,
                backgroundColor: selectedComps.includes(c.id)
                  ? colors.active_color
                  : colors.dot_color
              }}
            />
          </Wrapper>
        ))}
      </GoogleMapReact>
    </div>
  );
};
